<div
  [ngClass]="{ 'application-content': stepper.selected?.label === ApplicationStepperLabels.SUMMARY}"
>
  <div class="application-title-container" *ngIf="showTitle && stepper.selected?.label !== ApplicationStepperLabels.THANK_YOU_PAGE">
    <h1
      class="applicationTitle applicationTitle-navigation"
      appConfigSettingsTitle
      appConfigSettingsBackground
    >
      <span>
        {{ "ApplicationPage.GG_Title" | translate }}
      </span>
    </h1>
  </div>
  <div
    *ngIf="stepper.selected?.label !== ApplicationStepperLabels.IDENTITY_VERIFICATION && stepper.selected?.label !== ApplicationStepperLabels.THANK_YOU_PAGE"
    class="application-navigation"
  >
    <app-navigation-component
      (navigationStepsReady)="setActiveStep()"
      [productType]="productType"
    ></app-navigation-component>
  </div>
  <div class="application-stepper">
    <mat-horizontal-stepper
      (selectionChange)="stepperChangeHandler($event)"
      [linear]="isLinear"
      #stepper
    >
      <mat-step
        [label]="ApplicationStepperLabels.PRODUCT_INFO"
      >
        <ng-template matStepLabel>
          <div appConfigSettingsParagraph>{{'ApplicationPageGG.ProductDataTitle' | translate}}</div>
        </ng-template>
        <div class="secondTitle">
          <h2 appConfigSettingsSecondTitle>
            {{'ApplicationPageGG.ProductDataTitle' | translate}}
          </h2>
        </div>
        <app-product-info-page-gg #productInfo></app-product-info-page-gg>
        <div class="buttons-wrapper">
          <app-back-button
            [stepper]="stepper"
          ></app-back-button>
          <button
            appConfigSettingsPrimaryButton
            class="buttonRight primary"
            (click)="handleNextFromProductInfo()"
          >
            {{'ApplicationPage.Next' | translate}}
          </button>
        </div>
      </mat-step>
      <mat-step
        [label]="ApplicationStepperLabels.KNOWLEDGE_TEST_1"
      >
        <ng-template matStepLabel>
          <div appConfigSettingsParagraph>{{'ApplicationPageGG.KnowledgeTestTitle' | translate}}</div>
        </ng-template>
        <div class="secondTitle">
          <h2 appConfigSettingsSecondTitle>
            {{'ApplicationPageGG.KnowledgeTestTitle' | translate}}
          </h2>
        </div>
        <app-knowledge-test
          *ngIf="stepper.selected?.label === ApplicationStepperLabels.KNOWLEDGE_TEST_1"
          [page]="1"
          #knowledgeTest
        ></app-knowledge-test>
        <div class="buttons-wrapper">
          <app-back-button
            [stepper]="stepper"
          ></app-back-button>
          <button
            appConfigSettingsPrimaryButton
            class="buttonRight primary navigation-button"
            [ngClass]="{'knowledge-test-next-btn-active': stepper.selected?.label === ApplicationStepperLabels.KNOWLEDGE_TEST_1}"
            (click)="checkKnowledgePageAndGoNext(1)"
          >
            {{'ApplicationPage.Next' | translate}}
          </button>
        </div>
      </mat-step>
      <mat-step
        [label]="ApplicationStepperLabels.KNOWLEDGE_TEST_2"
      >
        <ng-template matStepLabel>
          <div appConfigSettingsParagraph>{{'ApplicationPageGG.KnowledgeTestTitle' | translate}}</div>
        </ng-template>
        <div class="secondTitle">
          <h2 appConfigSettingsSecondTitle>
            {{'ApplicationPageGG.KnowledgeTestTitle' | translate}}
          </h2>
        </div>
        <app-knowledge-test
          *ngIf="stepper.selected?.label === ApplicationStepperLabels.KNOWLEDGE_TEST_2"
          [page]="2"
          #knowledgeTest
        ></app-knowledge-test>
        <div class="buttons-wrapper">
          <app-back-button
            [stepper]="stepper"
          ></app-back-button>
          <button
            appConfigSettingsPrimaryButton
            class="buttonRight primary navigation-button"
            [ngClass]="{'knowledge-test-next-btn-active': stepper.selected?.label === ApplicationStepperLabels.KNOWLEDGE_TEST_2}"
            (click)="checkKnowledgePageAndGoNext(2)"
          >
            {{'ApplicationPage.Next' | translate}}
          </button>
        </div>
      </mat-step>
      <mat-step
        [label]="ApplicationStepperLabels.KNOWLEDGE_TEST_3"
      >
        <ng-template matStepLabel>
          <div appConfigSettingsParagraph>{{'ApplicationPageGG.KnowledgeTestTitle' | translate}}</div>
        </ng-template>
        <div class="secondTitle">
          <h2 appConfigSettingsSecondTitle>
            {{'ApplicationPageGG.KnowledgeTestTitle' | translate}}
          </h2>
        </div>
        <app-knowledge-test
          *ngIf="stepper.selected?.label === ApplicationStepperLabels.KNOWLEDGE_TEST_3"
          [page]="3"
          #knowledgeTest
        ></app-knowledge-test>
        <div
          class="buttons-wrapper"
        >
          <app-back-button
            [disabled]="knowledgeTestFormService.isTestCompleted && !knowledgeTestFormService.isTestPassed"
            [stepper]="stepper"
          ></app-back-button>
          <button
            *ngIf="knowledgeTestFormService.isTestPassed"
            [disabled]="!knowledgeTestFormService.isTestPassed"
            appConfigSettingsPrimaryButton
            class="buttonRight primary navigation-button"
            [ngClass]="{
              'disabled': !knowledgeTestFormService.isTestPassed,
              'knowledge-test-next-btn-active': stepper.selected?.label === ApplicationStepperLabels.KNOWLEDGE_TEST_3
            }"
            (click)="completeTest()"
          >
            {{'ApplicationPage.Next' | translate}}
          </button>
        </div>
      </mat-step>
      <mat-step
        [label]="ApplicationStepperLabels.PERSONAL_DATA"
      >
        <ng-template matStepLabel>
          <div appConfigSettingsParagraph>{{'ApplicationPageGG.ProductDataTitle' | translate}}</div>
        </ng-template>
        <div class="secondTitle">
          <h2 appConfigSettingsSecondTitle>
            {{'ApplicationPageGG.PersonalDataTitle' | translate}}
          </h2>
        </div>
        <app-application-insured
          [insuredFormGroup]="form.get('insured')"
        ></app-application-insured>
        <div class="buttons-wrapper">
          <app-back-button
            [stepper]="stepper"
          ></app-back-button>
          <button
            appConfigSettingsPrimaryButton
            class="buttonRight primary"
            (click)="handleNextFromInsured()"
          >
            {{'ApplicationPage.Next' | translate}}
          </button>
        </div>
      </mat-step>
      <mat-step
        [label]="ApplicationStepperLabels.PERSONAL_DATA"
      >
        <ng-template matStepLabel>
          <div appConfigSettingsParagraph>{{'ApplicationPageGG.ProductDataTitle' | translate}}</div>
        </ng-template>
        <div class="secondTitle">
          <h2 appConfigSettingsSecondTitle>
            {{'ApplicationPageGG.PersonalDataTitle' | translate}}
          </h2>
        </div>
        <app-personal-details-page-gg
          (destroyHandler)="this.personalDetailsDestroyHandler($event)"
          #personalDetails
        ></app-personal-details-page-gg>
        <div class="buttons-wrapper buttons-wrapper-half">
          <app-back-button
            [stepper]="stepper"
          ></app-back-button>
          <button
            appConfigSettingsPrimaryButton
            class="buttonRight primary"
            (click)="handleNextFromPersonalDetail()"
          >
            {{'ApplicationPage.Next' | translate}}
          </button>
        </div>
      </mat-step>
      <mat-step
        [label]="ApplicationStepperLabels.SUMMARY"
      >
        <ng-template matStepLabel>
          <div appConfigSettingsParagraph>{{'ApplicationPage.ClosingStatement' | translate}}</div>
        </ng-template>
        <app-final-page-gg
          [stepper]="this.stepper"
          (updateApplicationDto)="this.updateApplicationDto()"
          (downloadQuote)="downloadQuote()"
          (submitApplicationRequest)="submitApplication()"
        ></app-final-page-gg>
      </mat-step>
<!--      <mat-step-->
<!--        [label]="ApplicationStepperLabels.IDENTITY_VERIFICATION"-->
<!--      >-->
<!--        <app-application-idin-wrapper-->
<!--          [stepper]="this.stepper"-->
<!--          [applicationDto]="this.applicationDto"-->
<!--          (submitApplication)="this.submitApplication()"-->
<!--          (resetApplication)="this.resetApplication()"-->
<!--        ></app-application-idin-wrapper>-->
<!--      </mat-step>-->
      <mat-step
        [label]="ApplicationStepperLabels.THANK_YOU_PAGE"
      >
        <app-application-thank-you
          *ngIf="stepper.selected?.label === ApplicationStepperLabels.THANK_YOU_PAGE"
          subTitle="ThankYouPage.Insured1FirstParagraph_GG"
          secondParagraph="ThankYouPage.Insured1SecondParagraph_GG"
          thirdParagraph="ThankYouPage.Insured1ThirdParagraph_GG"
          fourthParagraph="ThankYouPage.Insured1FourthParagraph_GG"
          downloadPdf="ThankYouPage.DownloadPDF.0"
          (resetApplication)="this.resetApplication()"
        >
        </app-application-thank-you>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>
